import type { StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { FeatureViewed } from '@repo/segment/components/FeatureViewed';
import { renderStructuredContent } from '../../rendererContext';
import type { RendererProps } from '../../types';
import { isColorToken } from '../../utils/isColorToken';
import { COLORS_MAP } from '../constants';
import type { ColorToken } from '../types';

export type Props = StructuredContentDocument<{
  backgroundColor?: ColorToken | string;
  children: StructuredContentDocument;
  rendererProps?: RendererProps;
}>;

export function NWVerifiedContainer({ props }: Props) {
  const { children, backgroundColor = 'neutral-lightest', rendererProps } = props;

  const resolvedBackgroundColor = isColorToken(backgroundColor)
    ? COLORS_MAP[backgroundColor]
    : backgroundColor;

  return (
    <FeatureViewed entityName="banking_rating_methodology" entitySection="banking">
      <div
        className={css({
          position: 'relative',
          borderTopLeftRadius: { base: '[0]', sm: '3', md: '3' },
          borderTopRightRadius: { base: '[0]', sm: '3', md: '3' },
          borderBottomRightRadius: { base: '[0]', sm: '3', md: '3' },
          borderBottomLeftRadius: { base: '[0]', sm: '3', md: '3' },
          paddingTop: {
            base: '4',
            md: '6',
            lg: '8',
          },
          paddingRight: {
            base: '4',
            md: '6',
            lg: '8',
          },
          paddingBottom: {
            base: '4',
            md: '6',
            lg: '8',
          },
          paddingLeft: {
            base: '4',
            md: '6',
            lg: '8',
          },
        })}
        style={{ backgroundColor: resolvedBackgroundColor }}
      >
        {renderStructuredContent(children, rendererProps)}
      </div>
    </FeatureViewed>
  );
}
